import { data } from '../../svg/MoveToInbox/data';
import { makeIcon } from '../makeIcon';

export const MoveToInbox = makeIcon(data, 'move_to_inbox', 'MoveToInbox');

export default MoveToInbox;
